export default __webpack_public_path__ + "static/media/master-card.96621f6a.svg";